import script from "./ShareMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ShareMenu.vue?vue&type=style&index=0&id=7df30e32&lang=scss"

const __exports__ = script;

export default __exports__